module.exports = __webpack_public_path__ + "img/hand-raised.90b1db33.svg";